<div class="file-container">
	
	<div class="file-icon">
		
		<span class="material-symbols-outlined">image</span>
	
	</div>
	
	<div class="file-details">
		
		<div class="file-name">{{ file?.name }}</div>
		
		<div class="file-size">{{ FormatBytes(file?.size) }}</div>
		
	</div>
	
	<div class="controls">
	
		<button class="nlv-btn icon-only" (click)="deleteFile()">
			
			<span class="material-symbols-outlined">delete</span>
			
		</button>
	
	</div>

</div>
